import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from 'src/app/ClassFile/webapi.service';
import { Subject } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-package',
  templateUrl: './view-package.component.html',
  styleUrls: ['./view-package.component.scss']
})
export class ViewPackageComponent implements OnInit {

  getPackageList;

  labID = "";

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();

  constructor(private toastr: ToastrService,private webApiService: WebapiService,) {
    this.labID = sessionStorage.getItem("lab");
    this.ViewList();
   }

   ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ngOnInit(): void {
  }

  ViewList(){
 
    this.webApiService.packageList().subscribe((res => {
        console.log(res);

        if(res == ""){
          this.toastr.error("Empty Data", "NO Data Found");
        }else{
          this.getPackageList = res;
          this.dtTrigger.next();
          //console.log(this.getLabListArray);
        }

    }), (err) => {
        this.toastr.error(err.error.Error, 'Error!');
    })





  }

  deletePackage(id){


    Swal.fire({
      title: 'Are you sure?',
      text: "Do you want to Delete this Package?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#46DCBE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then((result) => {
      if (result.isConfirmed) {


        var data = {
          "id" : id
        }

        this.webApiService.deletePackage(data).subscribe((res => {

          console.log(res);
          this.toastr.success("Success", res.toString());
          this.ViewList();

          // if(res == ""){
          //   this.toastr.error("Empty Data", "NO Data Found");
          // }else{
          //   this.getLabListArray = res;
          //   //console.log(this.getLabListArray);
          // }

      }), (err) => {
        console.log(err);
          this.toastr.error(err.error.Error, 'Error!');
      })


      }
    })

  }




}


